export let SubAccountAccessTypeEnum;

(function (SubAccountAccessTypeEnum) {
  SubAccountAccessTypeEnum["DEFAULT_OFF"] = "defaultOff";
  SubAccountAccessTypeEnum["DEFAULT_ON"] = "defaultOn";
  SubAccountAccessTypeEnum["ALWAYS_ON"] = "alwaysOn";
})(SubAccountAccessTypeEnum || (SubAccountAccessTypeEnum = {}));